import React, { useContext } from "react";

// global state
import { StateContext } from "../../AppStateContext";

// Material uI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

const AddNewPropertyDataTypes = ({ dataTypes, propObj, setPropObj }) => {
  // global state
  const state = useContext(StateContext);
  return (
    <div className="__addPropertyDataTypeSelect">
      <label
        htmlFor="dataTypeModal"
        style={{ color: state.theme === "dark" ? "#e2e9ff" : "#00152b" }}
      >
        Data Type <span>*</span>
        <Tooltip
          placement="right-start"
          title="The name of the property should be descriptive (e.g. title, name, or summary). A property name starts with a lowercase letter, and concatenated words are camelCased (e.g. writtenBy, or publishedBy)."
        >
          <HelpIcon
            style={{
              fontSize: "15px",
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </label>
      <select
        name="dataTypeModal"
        id="dataTypeModal"
        defaultValue="Select a data type"
        className={
          state.theme === "dark"
            ? "__addPropertyDataTypeDark"
            : "__addPropertyDataTypeLight"
        }
        value={propObj.dataTypes}
        onChange={(e) => setPropObj({ ...propObj, dataType: [e.target.value] })}
      >
        <option selected disabled>
          Select a data type
        </option>
        {dataTypes.map((type, idx) => (
          <option
            key={idx}
            value={type.value}
            title={type.tooltip}
            id={`newPropertyDataType${type.value}`}
          >
            {type.value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AddNewPropertyDataTypes;
